import { ArtistsFilterState, DEFAULT_ARTIST_ID_VALUE } from './artists.types';

export const getDefaultArtistsFilter = (): ArtistsFilterState => ({
  selectedArtists: {
    [DEFAULT_ARTIST_ID_VALUE]: true,
  },
});
export const defaultArtistsFilter = getDefaultArtistsFilter();
